import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

//import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  DialogActions,
  DialogContent,
  Dialog,
  Alert,
} from "@mui/material";
import { Animated } from "react-animated-css";
import axios from "axios";

import img from "assets/img/pending.png";
import loaderGif from "assets/img/loading.gif";
import successImg from "assets/img/success.gif";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function RefundedPay(props) {
  const classes = useStyles();

  const [open] = useState(props.open);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [loader, setLoader] = useState(false);
  const [info, setInfo] = useState(true);
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
    img: "",
  });

  const { urlServices } = useContext(UrlServicesContext);

  const handleClose = () => {
    props.exit();
  };

  const handleSubmit = () => async () => {
    setInfo(false);
    setLoader(true);

    try {
      const response = await axios.post(
        `${urlServices}placetopay/reverse-pay/${props.id.responseTransaction.payment[0].internalReference}`
      );
      if (response.status === 200) {
        submitSave();
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const submitSave = async () => {
    const dataValue = {
      // responseTransaction: JSON.stringify(data),
      status: 4, // REEMBOLSO
    };

    try {
      const response = await axios.put(
        `${urlServices}payment-transaction/${props.id.id}`,
        dataValue
      );
      if (response.status === 200) {
        setLoader(false);
        setAlert({
          openAlert: true,
          errorAlert: "success",
          mensaje: "Pago reembolsado con éxito",
          img: successImg,
        });
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers>
          <Grid container className={classes.root}>
            <Grid item xs={12} sm={12}>
              {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
              {info ? (
                <Animated
                  animationIn="fadeIn"
                  animationInDuration={1000}
                  isVisible={true}
                >
                  <center>
                    <img
                      src={img}
                      alt="validate"
                      style={{
                        width: 80,
                      }}
                    />
                    <div className={classes.titleCardFilter}>
                      ¿Desea reembolsar este pago?
                    </div>
                    <br></br>
                    <ButtonStyle0
                      onClick={handleSubmit()}
                      className={classes.buttonSubmit}
                    >
                      Reembolsar
                    </ButtonStyle0>
                  </center>
                </Animated>
              ) : loader ? (
                <center>
                  <img
                    alt="loaderGif"
                    src={loaderGif}
                    style={{ width: 60, margin: "20% 0" }}
                  />
                </center>
              ) : (
                <center>
                  <img
                    src={alert.img}
                    alt="type"
                    style={{ width: 200, marginBottom: 20 }}
                  />
                  <Alert
                    severity={
                      alert.errorAlert === "success" ? "success" : "error"
                    }
                    icon={false}
                    sx={{ fontSize: 22 }}
                  >
                    {alert.mensaje}
                  </Alert>
                </center>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleClose}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
